import React from 'react';
import { PropTypes } from 'prop-types';
import { t } from '@lingui/macro';
import { Flex, Popover, Tag } from '@decisiv/ui-components';

import CheckCircle from '@decisiv/iconix/lib/components/CheckCircle';
import CheckCircleF from '@decisiv/iconix/lib/components/CheckCircleF';
import ExclamationTriangle from '@decisiv/iconix/lib/components/ExclamationTriangle';
import ExclamationTriangleF from '@decisiv/iconix/lib/components/ExclamationTriangleF';
import ExclamationShield from '@decisiv/iconix/lib/components/ExclamationShield';
import Hourglass from '@decisiv/iconix/lib/components/Hourglass';

import executionStatusColor from '../../utils/executionStatusColors';

export default function StatusTag({ status }) {
  const getStatusInfo = (logStatus) => {
    let statusText;
    let statusIcon;

    switch (logStatus) {
      case 'SUCCEEDED':
        statusText = t`Succeeded`;
        statusIcon = CheckCircleF;
        break;
      case 'ExecutionDoesNotExist':
        statusText = t`Over 90 days ago`;
        statusIcon = ExclamationTriangleF;
        break;
      case 'RUNNING':
        statusText = t`Processing`;
        statusIcon = Hourglass;
        break;
      case 'NOT_FOUND':
        statusText = 'Succeeded - No Results';
        statusIcon = CheckCircle;
        break;
      case 'COMPLETED_WITH_ERRORS':
        statusText = 'Completed with Errors';
        statusIcon = ExclamationTriangle;
        break;
      case 'BLOCKED_BY_CONDITION_RULE':
        statusText = 'Blocked By Condition Rule';
        statusIcon = ExclamationShield;
        break;
      case 'BLOCKED_BY_CIRCUIT_BREAKER':
        statusText = 'Blocked By Circuit Breaker';
        statusIcon = ExclamationShield;
        break;
      case 'RE_ENQUEUED_BY_CIRCUIT_BREAKER':
        statusText = 'Re Enqueued By Circuit Breaker';
        statusIcon = ExclamationShield;
        break;
      case 'FAILED':
      default:
        statusText = t`Failed`;
        statusIcon = ExclamationTriangle;
    }

    // Color is the single source of truth shared with the Integration Health dashboard.
    return {
      statusText,
      statusColor: executionStatusColor(logStatus),
      statusIcon,
    };
  };

  const { statusText, statusColor, statusIcon } = getStatusInfo(status);

  return (
    <Popover
      placement="bottom-start"
      manageEvents="hover"
      zIndex={999}
      target={({ ref }) => (
        <Tag
          ref={ref}
          aria-label={statusText}
          color={statusColor}
          icon={statusIcon}
          key="id"
          variant="outline"
          style={{ marginRight: 5 }}
        />
      )}
    >
      <Flex padding={1}>
        <span>{statusText}</span>
      </Flex>
    </Popover>
  );
}

StatusTag.propTypes = {
  status: PropTypes.string.isRequired,
};
